import { useCastersContext } from "@/pages/caster/caster-data-entry-v2/CastersContext";
import { MenuItem, Select } from "@mui/material";
interface Props {
	value: number | null;
	onChange: (value: number | null) => void;
	disabled?: boolean;
}

export const ScrapCodeSelector = ({ value, onChange, disabled }: Props) => {
	const { state } = useCastersContext();
	const scrapReasons = state.scrapReasons || [];

	return (
		<Select
			labelId="scrap-code-label"
			label="Code"
			value={value === null ? "" : value}
			onChange={(e) =>
				onChange(e.target.value === "" ? null : Number(e.target.value))
			}
			disabled={disabled}
		>
			<MenuItem value="">
				<em>None</em>
			</MenuItem>
			{scrapReasons.map((reason) => (
				<MenuItem key={reason.ScrapReasonId} value={reason.ScrapReasonId}>
					{reason.ScrapReasonName}
				</MenuItem>
			))}
		</Select>
	);
};
